import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "xmp-data-types"
    }}>{`XMP data types`}</h1>
    <p>{`This page defines a collection of XMP data types that are used to represent values of XMP properties`}</p>
    <h2 {...{
      "id": "basic-types"
    }}>{`Basic types`}</h2>
    <ol>
      <li parentName="ol">
        <h3 parentName="li" {...{
          "id": "boolean"
        }}>{`Boolean`}</h3>
        <p parentName="li">{`Boolean values shall be "`}<strong parentName="p">{`True`}</strong>{`" or "`}<strong parentName="p">{`False`}</strong>{`".`}</p>
      </li>
      <li parentName="ol">
        <h3 parentName="li" {...{
          "id": "date"
        }}>{`Date`}</h3>
        <p parentName="li">{`A date-time value is represented using a subset of the formats as defined in Date and Time Formats:  `}</p>
        <p parentName="li"><em parentName="p">{`YYYY`}</em><br parentName="p"></br>{`
`}<em parentName="p">{`YYYY-MM`}</em><br parentName="p"></br>{`
`}<em parentName="p">{`YYYY-MM-DD`}</em><br parentName="p"></br>{`
`}<em parentName="p">{`YYYY-MM-DDThh:mmTZD`}</em><br parentName="p"></br>{`
`}<em parentName="p">{`YYYY-MM-DDThh:mm:ssTZD`}</em><br parentName="p"></br>{`
`}<em parentName="p">{`YYYY-MM-DDThh:mm:ss.sTZD`}</em>{`  `}</p>
        <p parentName="li">{`In which:`}<br parentName="p"></br>{`
`}{`• `}<strong parentName="p">{`YYYY`}</strong>{` = four-digit year`}<br parentName="p"></br>{`
`}{`• `}<strong parentName="p">{`MM`}</strong>{` = two-digit month (01=January)`}<br parentName="p"></br>{`
`}{`• `}<strong parentName="p">{`DD`}</strong>{` = two-digit day of month (01 to 31)`}<br parentName="p"></br>{`
`}{`• `}<strong parentName="p">{`hh`}</strong>{` = two digits of hour (00 to 23)`}<br parentName="p"></br>{`
`}{`• `}<strong parentName="p">{`mm`}</strong>{` = two digits of minute (00 to 59)`}<br parentName="p"></br>{`
`}{`• `}<strong parentName="p">{`ss`}</strong>{` = two digits of second (00 to 59)`}<br parentName="p"></br>{`
`}{`• `}<strong parentName="p">{`s`}</strong>{` = one or more digits representing a decimal fraction of a second`}<br parentName="p"></br>{`
`}{`• `}<strong parentName="p">{`TZD`}</strong>{` = time zone designator (Z or +hh:mm or -hh:mm  `}</p>
        <p parentName="li">{`The time zone designator need not be present in XMP. When not present, the time zone is unknown, and an XMP processor should not assume anything about the missing time zone.  `}</p>
        <p parentName="li">{`Local time-zone designators +hh:mm or -hh:mm should be used when possible instead of converting to UTC.  `}</p>
        <p parentName="li"><strong parentName="p">{`NOTE`}</strong>{` : If a file was saved at noon on October 23, a timestamp of 2004-10-23T12:00:00-06:00 conveys more information than 2004-10-23T18:00:00Z.`}</p>
      </li>
      <li parentName="ol">
        <h3 parentName="li" {...{
          "id": "integer"
        }}>{`Integer`}</h3>
        <p parentName="li">{`A signed or unsigned numeric string used as an integer number representation. The string consists of an arbitrary-length decimal numeric string with an optional leading “+” or “–” sign.`}</p>
      </li>
      <li parentName="ol">
        <h3 parentName="li" {...{
          "id": "real"
        }}>{`Real`}</h3>
        <p parentName="li">{`A simple text value denoting a floating-point numeric value, written using decimal notation of an optional sign followed by an integer part and a fraction part. Either the integer part or the fraction part, but not both, may be omitted. The sign, if present, is "+" (U+002B) or "-" (U+002D). The integer part, if present, is a sequence of one or more decimal digits (U+0030 to U+0039). The fraction, if present, is a decimal point (".", U+002E) followed by a sequence of one or more decimal digits.  `}</p>
        <p parentName="li">{`The precise range and precision for the general type are not specified by this document. If converted to a binary value, an XMP processor shall support at least the 32-bit IEEE 754 range and precision, and it should support at least the 64-bit IEEE 754 range and precision. A particular use of the Real type may specify a required range or precision, such as nonnegative or microsecond resolution (for a duration in seconds).`}</p>
      </li>
      <li parentName="ol">
        <h3 parentName="li" {...{
          "id": "text"
        }}>{`Text`}</h3>
        <p parentName="li">{`A possibly empty Unicode string.`}</p>
      </li>
    </ol>
    <h2 {...{
      "id": "derived-types"
    }}>{`Derived types`}</h2>
    <ol>
      <li parentName="ol">
        <h3 parentName="li" {...{
          "id": "agent-name"
        }}>{`Agent Name`}</h3>
        <p parentName="li">{`The name of an XMP processor, a `}<em parentName="p">{`Text`}</em>{` value. It is recommended that the value use this format convention:It is recommended that the value use this format convention:  `}</p>
        <p parentName="li"><em parentName="p">{`Organization Software_name Version (token;token;...)`}</em></p>
        <ul parentName="li">
          <li parentName="ul">
            <p parentName="li">{`Organization: The name of the company or organization providing the software, no SPACEs.`}</p>
          </li>
          <li parentName="ul">
            <p parentName="li">{`Software_name: The full name of the software, SPACEs allowed.`}</p>
          </li>
          <li parentName="ul">
            <p parentName="li">{`version: The version of the software, no SPACEs.`}</p>
          </li>
          <li parentName="ul">
            <p parentName="li">{`tokens: Can be used to identify an operating system, plug-in, or more detailed version information.  `}</p>
            <p parentName="li"><strong parentName="p">{`EXAMPLE`}</strong>{`: `}<em parentName="p">{`"Adobe Acrobat 9.0 (Mac OS X 10.5)"`}</em></p>
          </li>
        </ul>
      </li>
      <li parentName="ol">
        <h3 parentName="li" {...{
          "id": "choice"
        }}>{`Choice`}</h3>
        <p parentName="li">{`A value chosen from a vocabulary of values. Vocabularies provide a means of specifying a limited and possibly extensible set of values for a property.  `}</p>
        <p parentName="li">{`A choice can be open or closed:`}</p>
        <ul parentName="li">
          <li parentName="ul">{`An open choice has one or more lists of preferred values, but other values can be used freely.`}</li>
          <li parentName="ul">{`A closed choice has one or more lists of allowed values, other values shall not be used.`}<br parentName="li"></br>
            <strong parentName="li">{`NOTE`}</strong>{` An XMP reader would be more robust if it tolerated unexpected values for closed choice types when the set of allowed values can be expected to grow over time.`}</li>
        </ul>
      </li>
      <li parentName="ol">
        <h3 parentName="li" {...{
          "id": "guid"
        }}>{`GUID`}</h3>
        <p parentName="li">{`A string representing a “globally unique identifier”. A GUID shall be a normal (non-URI) simple value, even though it might appear similar to a URI string. This document does not require any particular methodology for creating a GUID, nor does it require any specific means of formatting the GUID as a simple XMP value. The only valid operations on GUIDs are to create them, to assign one to another, and to compare two of them for equality. This comparison shall use the Unicode string value as-is, using a direct byte-for-byte check for equality.`}</p>
      </li>
      <li parentName="ol">
        <h3 parentName="li" {...{
          "id": "language-alternative"
        }}>{`Language Alternative`}</h3>
        <p parentName="li">{`An alternative array of simple text items. Language alternatives facilitate the selection of a simple text item based on a desired language. Each array item shall have an xml:lang qualifier. Each xml:lang value shall be unique among the items. As defined in IETF RFC 3066, the xml:lang value is composed of one or more parts: a primary language subtag and a (possibly empty) series of subsequent subtags. The same primary subtag may be used alone and in conjunction with one or more lower-level subtags. A default value, if known, should be the first array item. The order of other array items is not specified by this document.  `}</p>
        <p parentName="li">{`An xml:lang value of "x-default" may be used to explicitly denote a default item. If used, the "x-default" item shall be first in the array and its simple text value should be repeated in another item in which xml:lang specifies its actual language. However, an "x-default" item may be the only item, in which case there is only a default value in no defined language.`}</p>
      </li>
      <li parentName="ol">
        <h3 parentName="li" {...{
          "id": "locale"
        }}>{`Locale`}</h3>
        <p parentName="li">{`A simple text value denoting a language code as defined in IETF RFC 3066.`}</p>
      </li>
      <li parentName="ol">
        <h3 parentName="li" {...{
          "id": "mimetype"
        }}>{`MIMEType`}</h3>
        <p parentName="li">{`A simple text value denoting a digital file format as defined in IETF RFC 2046.`}</p>
      </li>
      <li parentName="ol">
        <h3 parentName="li" {...{
          "id": "propername"
        }}>{`ProperName`}</h3>
        <p parentName="li">{`A simple text value denoting the name of a person or organization.`}</p>
      </li>
      <li parentName="ol">
        <h3 parentName="li" {...{
          "id": "renditionclass"
        }}>{`RenditionClass`}</h3>
        <p parentName="li">{`A simple text Open Choice value denoting the form or intended usage of a resource. A series of colonseparated (":", U+003A) tokens and parameters, the first of which names the basic usage of the rendition. Additional tokens need not be present; they provide specific characteristics of the rendition.  `}</p>
        <p parentName="li">{`Defined values for rendition tokens`}</p>
        <table parentName="li">
          <thead parentName="table">
            <tr parentName="thead">
              <th parentName="tr" {...{
                "align": null
              }}>{`Token`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`Defined value`}</th>
            </tr>
          </thead>
          <tbody parentName="table">
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`default`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`The master resource; no additional tokens allowed.`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`draft`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`A review rendition.`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`low-res`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`A low-resolution, full-size stand-in.`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`proof`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`A review proof.`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`screen`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`Screen resolution or Web rendition.`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`thumbnail`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`A simplified or reduced preview. Additional tokens can provide characteristics. The recommended order is: thumbnail:format:size:colorspace. EXAMPLE thumbnail:jpeg, thumbnail:16x16, thumbnail:gif:8x8:bw.`}</td>
            </tr>
          </tbody>
        </table>
      </li>
    </ol>
    <ol {...{
      "start": 9
    }}>
      <li parentName="ol">
        <h3 parentName="li" {...{
          "id": "uri"
        }}>{`URI`}</h3>
        <p parentName="li">{`Text denoting an Internet Uniform Resource Identifier as defined in IETF RFC 3986.`}</p>
      </li>
      <li parentName="ol">
        <h3 parentName="li" {...{
          "id": "resourceref"
        }}>{`ResourceRef`}</h3>
        <p parentName="li">{`A structure denoting a multiple-component reference to a resource. The field values are taken from various properties in the referenced resource.  `}</p>
        <ul parentName="li">
          <li parentName="ul">{`The field namespace URI shall be "`}<a parentName="li" {...{
              "href": "http://ns.adobe.com/xap/1.0/sType/ResourceRef#%22"
            }}>{`http://ns.adobe.com/xap/1.0/sType/ResourceRef#"`}</a>{`.`}</li>
          <li parentName="ul">{`The preferred field namespace prefix is stRef.`}<br parentName="li"></br>
            {`Following table lists the fields available in ResourceRef. Fields need not be present. The fields, if used, shall be of the specified types. The field content should be as described. 8.2.2.10 URI  `}</li>
        </ul>
        <p parentName="li">{`ResourceRef fields`}</p>
        <table parentName="li">
          <thead parentName="table">
            <tr parentName="thead">
              <th parentName="tr" {...{
                "align": null
              }}>{`Name`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`Type`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`Field content`}</th>
            </tr>
          </thead>
          <tbody parentName="table">
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`stRef:documentID`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`GUID`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`The value of the xmpMM:DocumentID property from the referenced resource.`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`stRef:filePath`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`URI`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`The referenced resource’s file path or URL.`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`stRef:instanceID`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`GUID`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`The value of the xmpMM:InstanceID property from the referenced resource.`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`NOTE`}</strong>{` The difference in capitalization between stRef:documentID and xmpMM:DocumentID is real, the result of historical accident. This is also true of the other ResourceRef fields.`}</td>
              <td parentName="tr" {...{
                "align": null
              }}></td>
              <td parentName="tr" {...{
                "align": null
              }}></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`stRef:renditionClass`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`RenditionClass`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`The value of the xmpMM:RenditionClass property from the referenced resource.`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`stRef:renditionParam`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`Text`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`The value of the xmpMM:RenditionParams property from the referenced resource.`}</td>
            </tr>
          </tbody>
        </table>
      </li>
      <li parentName="ol">
        <h3 parentName="li" {...{
          "id": "url"
        }}>{`URL`}</h3>
        <p parentName="li">{`Text denoting an Internet Uniform Resource Locator as defined in URIs, URLs, and URNs: Clarifications and Recommendations.`}</p>
      </li>
      <li parentName="ol">
        <h3 parentName="li" {...{
          "id": "rational"
        }}>{`Rational`}</h3>
        <p parentName="li">{`To represent Exif rational values in XMP, they must be converted to text. The recommended approach is to use a value of type Text of the form numerator /denominator. For example, the value 2/3 becomes the text value "2/3" when converted to XMP.`}</p>
      </li>
      <li parentName="ol">
        <h3 parentName="li" {...{
          "id": "framerate"
        }}>{`FrameRate`}</h3>
        <p parentName="li">{`A frame-rate value can be part of the FrameCount specification of a Marker. For Markers within a Track, however, the frame count can     be a simple integer, and the associated frame rate is specified separately, in the xmpDM:frameRate of the Track.`}</p>
        <p parentName="li">{`A frame rate is expressed as a number of frames divided by a number of seconds (f/s). The number of seconds is called the rate           basis; it defaults to 1, for the common frames-per-second (fps) expression. If no frame rate is specified in either the frame count     itself or in the associated track, the frame count is also the number of seconds, at the default rate of 1 fps.`}<br parentName="p"></br>{`
`}{`The string value is in one of these formats:`}</p>
        <table parentName="li">
          <thead parentName="table">
            <tr parentName="thead">
              <th parentName="tr" {...{
                "align": null
              }}>{`Name`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`Field content`}</th>
            </tr>
          </thead>
          <tbody parentName="table">
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`"f###"`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`The frame rate in frames-per-second (fps). The rate basis is assumed to be 1. For example, a frame rate of 24fps is specified as “f24”.`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`"f###s###"`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`Specifies a frame rate with a rate basis. The second number is the rate basis, a number of seconds. For example, the         NTSC 29.97 frame rate is specified as “f30000s1001”`}</td>
            </tr>
          </tbody>
        </table>
      </li>
      <li parentName="ol">
        <h3 parentName="li" {...{
          "id": "framecount"
        }}>{`FrameCount`}</h3>
        <p parentName="li">{`A number of frames at a given frame rate, which specifies an audio or video time value for a Marker (as the value of `}<em parentName="p">{`xmpDM:duration or xmpDM:startTime`}</em>{`). Can also be used in the time portion of a document Part.`}</p>
        <p parentName="li">{`The frame-count value can include the frame rate as shown. For a Marker within a Track, the frame rate can be specified separately in the `}<em parentName="p">{`xmpDM:frameRate`}</em>{` of the Track.`}</p>
        <p parentName="li">{`The string value is in one of these formats:`}</p>
        <table parentName="li">
          <thead parentName="table">
            <tr parentName="thead">
              <th parentName="tr" {...{
                "align": null
              }}>{`Name`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`Field content`}</th>
            </tr>
          </thead>
          <tbody parentName="table">
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`"##"`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`For a Marker that is not in a Track, a simple integer value is interpreted as a number of seconds, at the default frame rate of 1 fps. For Markers within a Track, an integer value is interpreted as ticks/frames in the timescale specified by the track’s xmpDM:frameRate. When the count is zero, no frame rate should be specified.`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`"##f###" or "##f###s###"`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`A number of frames specified together with a FrameRate, which can contain an optional rate basis. The rate basis defaults to 1. These examples show how a FrameCount value of 15 is expressed for common video and audio frame rates: Film at 24 fps (frame rate = 24, rate basis = 1): "15f24", Speech-to-text in milliseconds (frame rate = 1000, rate basis = 1): "15f1000", NTSC at 29.97 fps (frame rate = 30000, rate basis = 1001): "15f30000s1001", DVATicks (frame rate = 254016000000, rate basis = 1): "15f254016000000"`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`"maximum"`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`Allowed for a duration value; indicates that the time span is unlimited, or is determined automatically up to the full duration of the source.`}</td>
            </tr>
          </tbody>
        </table>
      </li>
      <li parentName="ol">
        <h3 parentName="li" {...{
          "id": "part"
        }}>{`Part`}</h3>
        <p parentName="li">{`A Unicode string that identifies a portion of a resource. This is typically a general or logical portion, rather than a specific physical portion. For example, the metadata or the content, or the audio portion of a movie or the video portion.`}</p>
        <p parentName="li">{`Part names are a hierarchy of arbitrary depth, specified using path syntax where levels in the hierarchy shall be indicated by a slash ("/", U+002F). The slash shall not be used for any other purpose in these strings. The leftmost character shall be a slash. A path may be just a slash, indicating any or all parts.`}</p>
        <p parentName="li">{`All paths implicitly encompass further descendants. For example, "/content" includes all content, whereas "/content/audio" includes all audio but excludes other content such as "/content/video". The collection of part components is open. Additional levels of subparts or alternatives for existing levels may be used; for example, "/content/audio/channels/left" or "/content/audio/FFTaudio/high". When such subparts are used, each subpart name shall be unique and signify a component that is disjoint from any of its siblings.`}</p>
        <p parentName="li">{`A part component name shall follow a restricted syntax of an XML Name as defined in Extensible Markup Language. At most one colon (":" U+003A) shall be used, and a colon shall not be the first character. Of the XML Name characters below U+0080, only "A" through "Z", "a" through "z", "0" through "9", and colon may be used. Other XML Name characters below U+0080 are reserved for future use. XMP readers should tolerate reserved characters, and should ignore the remainder of a path from the leftmost component containing a reserved character.`}</p>
        <table parentName="li">
          <thead parentName="table">
            <tr parentName="thead">
              <th parentName="tr" {...{
                "align": null
              }}>{`Part specification`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`Part that changed or is referenced`}</th>
            </tr>
          </thead>
          <tbody parentName="table">
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`/`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`Any (specific part unknown) or all (all parts of the content and metadata).`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`/metadata`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`Portions of the metadata.`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`/content`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`Any or all of the content (non-metadata).`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`/content/audio`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`Any or all sound.`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`/content/visual`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`Some image data (video or still).`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`/content/visual/video`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`Video or animation.`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`/content/visual/raster`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`Static raster image.`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`/content/visual/vector`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`Static vector image.`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`/content/visual/form/data`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`Form field data.`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`/content/visual/form/template`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`Form template.`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`/content/visual/annots`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`Applied annotations (comments).`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`[/]`}{`time:##, `}{`[/]`}{`time:##d##, `}{`[/]`}{`time:##r##`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`A time, duration, or time range specifier. May be standalone (meaning all parts starting at the time or within the range specified) or may be added to any of the listed specifications. `}<strong parentName="td">{`##`}</strong>{`: The start time, a frame count, `}<strong parentName="td">{`##d##`}</strong>{`: Duration (start time and duration time) , `}<strong parentName="td">{`##r##`}</strong>{`: Range (start time and end time). Each ## value is a FrameCount specifier, which can include an optional frame rate. The default frame rate is 1fps. The default duration is "maximum", the entire length of the asset.In a fromPart or toPart value, the leading / is optional. For an stEvt:changed part descriptor in a history record, the leading / is required. For a fromPart value, the start time is an offset from the start of the current ingredient’s file. For a toPart value, the start time is measured from the start of the destination file. If time values are not specifically given, the default start time is 0, meaning the beginning of the relevant file.`}</td>
            </tr>
          </tbody>
        </table>
      </li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      